'use strict';

(function ($) {

	var _selectors = {
		// Global: Placeholder to determine where to put this component on viewport/page.
		referenceItem: '[data-js-m-sticky-contact__placeholder]',
		referenceItemHome: '[data-js-m-sticky-contact__placeholder-home]',
		item: '[data-js-m-sticky-contact__item]'
	};

	var _stateClasses = {
		componentFadeIn: 'state-fadeIn',
		componentFadeOut: 'state-fadeOut',
		componentIsSticky: 'state-isSticky'
	};

	var _eventNames = {
		navigationFlyoutToggle: 'navigation-flyout-toggle'
	};

	// offset for standard case is negative, since the contact item needs to be aligned with the bottom of the title
	// which means it needs to be higher (=negative offset) than the top of the title
	var _offsetFromTitleBottom = {
		smallUp: -19,
		mediumUp: -11
	};

	// offset for the homepage case is positive since the contact item needs to be below the main tag
	var _offsetFromMainTag = {
		smallUp: 5,
		mediumUp: 26
	};

	var _offsetStickyTrigger = {
		smallUp: 128,
		largeUp: 160
	};

	/**
  * StickyContact
  *
  * @author Zorica Janjic <zorica.janjic@namics.com>
  */
	T.Module.StickyContact = T.createModule({
		start: function start(resolve) {
			this.$ctx = $(this._ctx);

			// References
			this.$referenceItem = $(_selectors.referenceItem);
			this.$referenceItemHome = $(_selectors.referenceItemHome);

			// Global Event Binding
			this._events.on('viewport.match', this.onViewportMatch.bind(this));
			this._events.on(_eventNames.navigationFlyoutToggle, this.onNavigationToggle.bind(this));

			// Component Event Binding: Event Delegation
			this.$ctx.on('click', _selectors.item, this.onClickItem.bind(this));

			// Config
			this.waypoint = null;

			this.initializeWaypoints();

			resolve();
		},


		/**
   * Initialize the waypoints object
   *
   * @returns {undefined} void
   */
		initializeWaypoints: function initializeWaypoints() {

			var referenceItem = this.$referenceItem;
			if (this.$referenceItemHome.length > 0) {
				referenceItem = this.$referenceItemHome;
			}

			if (referenceItem.length) {
				this.waypoint = new Waypoint({
					element: referenceItem[0],
					handler: this.onWaypointsTrigger.bind(this)
				});
			}

			// we disable it initially and enable it by vp change event
			this.disableWaypoints();
		},


		/**
   * Enable the waypoints functionality
   *
   * @returns {undefined} void
   */
		enableWaypoints: function enableWaypoints() {
			if (this.waypoint !== null) {
				this.waypoint.enable();
			}
		},


		/**
   * Disable the waypoints functionality
   *
   * @returns {undefined} void
   */
		disableWaypoints: function disableWaypoints() {
			if (this.waypoint !== null) {
				this.waypoint.disable();
			}

			// remove possible stuck class
			this.$ctx.removeClass('state-isSticky');
		},


		/**
   * Update the sticky offset depending on the logo height
   *
   * @param {number} offset The new offset to set
   * @returns {undefined} void
   */
		setOffsetAndRefresh: function setOffsetAndRefresh(offset) {
			if (this.waypoint !== null) {
				this.waypoint.options.offset = offset;

				// refresh waypoints after sticky offset change
				Waypoint.refreshAll();
			}
		},


		/**
   * Hides the sticky contact in case the navigation is opened.
   *
   * @returns {undefined} void
   */
		onNavigationToggle: function onNavigationToggle() {
			if (this.$ctx.hasClass(_stateClasses.componentFadeOut)) {
				this.$ctx.removeClass(_stateClasses.componentFadeOut);
			} else {
				this.$ctx.addClass(_stateClasses.componentFadeOut);
			}
		},


		/**
   * Handler for clicking on element
   *
   * @param {event} event Event
   * @returns {undefined} void
   */
		onClickItem: function onClickItem(event) {
			event.preventDefault();
			this._events.emit('contactbox.open');
		},


		/**
   * Sets position of contact button when not sticky
   * Contact button should be aligned with bottom of the Page Title
   *
   * @param {number} compensationOffset - offset needed for line height compensation / homepage offset
   * @returns {undefined} void
   */
		setPosition: function setPosition(compensationOffset) {

			var contactInitPosition = this.getInitialTopPosition(compensationOffset);
			this.$ctx.css('top', contactInitPosition);

			// refresh waypoints after sticky item position change
			Waypoint.refreshAll();
		},


		/**
   * Returns inital top position for this component.
   * @param {number} compensationOffset - offset needed for line height compensation / homepage offset
   * @returns {number} top position
   */
		getInitialTopPosition: function getInitialTopPosition(compensationOffset) {
			var contactInitPosition = 0;
			var referenceItemTop = 0;

			// Return if placeholder not found
			if (!this.$referenceItem.length && !this.$referenceItemHome.length) {
				return contactInitPosition;
			}

			if (this.$referenceItemHome.length > 0) {
				//	Case Homepage: Sticky Contact needs to be between the stage and the career teaser
				referenceItemTop = this.$referenceItemHome.offset().top;
			} else {
				//	Sticky Contact needs to be aligned with the bottom of Page Title.
				referenceItemTop = this.$referenceItem.offset().top;
			}

			contactInitPosition = referenceItemTop + compensationOffset;

			return contactInitPosition;
		},


		/**
   * Event when the waypoint of the sticky item gets triggered
   *
   * @param {event} direction The direction of scrolling
   * @returns {undefined} void
   */
		onWaypointsTrigger: function onWaypointsTrigger(direction) {
			if (direction === 'down') {
				this.$ctx.addClass('state-isSticky');
			} else {
				this.$ctx.removeClass('state-isSticky');
			}
		},


		/**
   * Event from enquire when a cerain viewport was triggered
   *
   * @param {event} viewPortName The new viewport name
   * @returns {undefined} void
   */
		onViewportMatch: function onViewportMatch(viewPortName) {
			var _this = this;

			var referenceItemOffset = _offsetFromTitleBottom;

			// if we are on the homepage, we need a different referenceItemOffset
			if (this.$referenceItemHome.length > 0) {
				referenceItemOffset = _offsetFromMainTag;
			}

			var whitelist = {
				'phone-down': function phoneDown() {
					_this.disableWaypoints();
				},
				'small-up': function smallUp() {
					_this.enableWaypoints();
				},
				'small': function small() {
					_this.setPosition(referenceItemOffset.smallUp);
					_this.setOffsetAndRefresh(_offsetStickyTrigger.smallUp - referenceItemOffset.smallUp);
				},
				'medium': function medium() {
					_this.setPosition(referenceItemOffset.mediumUp);
					_this.setOffsetAndRefresh(_offsetStickyTrigger.smallUp - referenceItemOffset.mediumUp);
				},
				'large': function large() {
					_this.setPosition(referenceItemOffset.mediumUp);
					_this.setOffsetAndRefresh(_offsetStickyTrigger.largeUp - referenceItemOffset.mediumUp);
				},
				'xlarge-up': function xlargeUp() {
					_this.setPosition(referenceItemOffset.mediumUp);
					_this.setOffsetAndRefresh(_offsetStickyTrigger.largeUp - referenceItemOffset.mediumUp);
				}
			};

			if ({}.hasOwnProperty.call(whitelist, viewPortName)) {
				whitelist[viewPortName]();
			}
		}
	});
})(jQuery);